import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../../../environments/environment';
import { T2ThemeService } from 'app/trip2-theme/t2-theme.service';

@Component({
  selector: 'app-external-unprocess-claims',
  templateUrl: './external-unprocess-claims.component.html',
  styleUrls: ['./external-unprocess-claims.component.scss'],
})
export class ExternalUnprocessClaimsComponent implements OnInit {
  public url: any;
  constructor(
    public sanitizer: DomSanitizer,
    private t2templateService: T2ThemeService
  ) {}

  ngOnInit() {
    this.getTokeToProvider();
  }
  private getTokeToProvider() {
    this.t2templateService.getProviderToken().subscribe((resp) => {
      if (resp != undefined && resp != null) {
        const urlRedirect = `${environment.url_webapp}/${resp.value}/billing_v1_unprocessedClaims`;
        this.url = this.sanitizer.bypassSecurityTrustResourceUrl(urlRedirect);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/external-billing/external-unprocess-claims/external-unprocess-claims.component.ts